<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ 'software.artifact.version' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['version']"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.artifact.size' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['size']"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.artifact.buildNumber' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['buildNumber']"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'software.artifact.branchName' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['branchName']"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'software.artifact.url' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['url']"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.artifact.status' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['status']" [inputType]="'select'" [selectValues]="softwareArtifactStatusItems" [selectNames]="softwareArtifactStatusNames" [translateSelect]="false"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.artifact.releaseType' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['releaseType']" [inputType]="'select'" [selectValues]="softwareArtifactReleaseTypeIds" [selectNames]="softwareArtifactReleaseTypeNames" [translateSelect]="false"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'software.artifact.changelog' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['changelog']" inputType="textarea"></app-input-with-error>
    </div>
    <app-error [error]="error"></app-error>
  </div>
</form>
